import { makeStyles } from "@material-ui/core";
export default makeStyles((theme)=>({
    primary:{
        textAlign: "center",
        backgroundColor: "#009bdb",
        borderRadius:"50px",
        width:"70%",
        color: "white",
        fontWeight: "900",
        fontFamily: "Montserrat",
        margin: theme.spacing(3),
        padding: theme.spacing(1),
        '&:hover':{
            backgroundColor: "#69a33b",
        }
    },
}))

